module.exports = __webpack_public_path__ + "img/FR16618.ef3d7623.png";